import { getThemeColor } from '@design/design-tokens/themes/theme-utils';
import { DesignToken, ThemeName } from '@design/design-tokens/themes/themes';
import { hexToRgba } from '@design/utils/color-conversion/color-conversion';

import { PieChartData } from './PieChart';

export const getColors = (theme: ThemeName) => {
  const normalColors = Array.from({ length: 5 }, (_, i) =>
    getThemeColor(`--chart-multi-lines-hex-${i + 1}` as DesignToken, theme)
  );
  const blurColors = normalColors.map(color =>
    hexToRgba({ hex: color, alpha: 0.15 })
  );

  return {
    normalColors,
    blurColors,
  };
};

export const createPieSeries = (data: PieChartData, theme: ThemeName) => {
  const { normalColors, blurColors } = getColors(theme);
  return [
    {
      top: 'top',
      center: ['50%', '48%'],
      type: 'pie',
      radius: ['60%', '95%'],
      label: { show: false },
      itemStyle: {
        borderColor: getThemeColor('--border-soft', theme),
        borderWidth: 1,
      },
      emphasis: {
        focus: 'self',
        scale: false,
      },
      blur: {
        itemStyle: { opacity: 1 },
      },
      labelLine: { show: false },
      data: data.map((item, idx) => ({
        ...item,
        itemStyle: {
          color: normalColors[idx],
        },
        emphasis: {
          itemStyle: {
            color: normalColors[idx],
          },
        },
        blur: {
          itemStyle: {
            color: blurColors[idx],
          },
        },
      })),
    },
  ];
};
